import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-thank-you-message',
  templateUrl: './thank-you-message.component.html',
  styleUrls: ['./thank-you-message.component.css']
})
export class ThankYouMessageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
